module.exports = __webpack_public_path__ + "img/card.ca6975ec.png";